import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  orderCardContainer: {
    padding: theme.spacing(2),
    paddingRight: 3,
    width: 180
  },
  orderCard: {
    padding: 12,
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap"
  },
  openOrdersTitle: {
    textAlign: "right",
    marginRight: theme.spacing(0.5)
  },
  openOrdersCount: {
    fontSize: 56,
    lineHeight: 1,
    fontWeight: theme.typography.fontWeightLight
  }
}));
